import { GeometryExtentUtility } from "../../../utility/common/GeometryExtentUtility";

/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-07-02 14:27:54
 * @LastEditTime: 2020-06-04 19:42:51
 * @LastEditors: Please set LastEditors
 */
export const UCDistictEvent =
{

    // UCDistictEvent_cityPickerChanger:"event_UCDistictEvent_cityPickerChanger"

    UCDistrictCity_event_cityClickHandler: "UCDistrictCity_event_cityClickHandler",

    UCDistrict_event_ucClick: "UCDistrict_event_ucClick",
}


export const UCDistrictData =
{
    province: { "name": "全省", "code": "62" },

    hotCityData: [
        
        { "name": "兰州市", "code": "620100" },
        { "name": "嘉峪关", "code": "620200" },
        { "name": "金昌市", "code": "620300" },
        { "name": "白银市", "code": "620400" },
        { "name": "天水市", "code": "620500" },
        { "name": "武威市", "code": "620600" },
        { "name": "张掖市", "code": "620700" },
        { "name": "平凉市", "code": "620800" },
        { "name": "酒泉市", "code": "620900" },
        { "name": "庆阳市", "code": "621000" },
        { "name": "定西市", "code": "621100" },
        { "name": "陇南市", "code": "622600" },
        { "name": "临夏州", "code": "622900" },
        { "name": "甘南州", "code": "623000" }
    ],


    xzqData: {
        "62": [{ "name": "兰州市", "code": "620100" },
        { "name": "嘉峪关", "code": "620200" }, { "name": "金昌市", "code": "620300" },
        { "name": "白银市", "code": "620400" }, { "name": "天水市", "code": "620500" },
        { "name": "武威市", "code": "620600" }, { "name": "张掖市", "code": "620700" },
        { "name": "平凉市", "code": "620800" }, { "name": "酒泉市", "code": "620900" },
        { "name": "庆阳市", "code": "621000" }, { "name": "定西市", "code": "621100" },
        { "name": "陇南市", "code": "622600" }, { "name": "临夏州", "code": "622900" },
        { "name": "甘南州", "code": "623000" }],
        
        "623000": [{ "name": "合作市", "code": "623001" }, { "name": "临潭县", "code": "623021" },
        { "name": "卓尼县", "code": "623022" }, { "name": "舟曲县", "code": "623023" },
        { "name": "迭部县", "code": "623024" }, { "name": "玛曲县", "code": "623025" },
        { "name": "碌曲县", "code": "623026" }, { "name": "夏河县", "code": "623027" }],
        "620100": [{ "name": "城关区", "code": "620102" }, { "name": "七里河区", "code": "620103" },
        { "name": "西固区", "code": "620104" }, { "name": "安宁区", "code": "620105" },
        { "name": "红古区", "code": "620111" }, { "name": "永登县", "code": "620121" },
        { "name": "皋兰县", "code": "620122" }, { "name": "榆中县", "code": "620123" }],
        "620200": [{ "name": "嘉峪关", "code": "620200" }],
        "620300": [{ "name": "金川区", "code": "620302" }, { "name": "永昌县", "code": "620321" }],
        "620400": [{ "name": "白银区", "code": "620402" }, { "name": "平川区", "code": "620403" },
        { "name": "靖远县", "code": "620421" }, { "name": "会宁县", "code": "620422" },
        { "name": "景泰县", "code": "620423" }],
        "620500": [{ "name": "秦州区", "code": "620502" }, { "name": "麦积区", "code": "620503" },
        { "name": "清水县", "code": "620521" }, { "name": "秦安县", "code": "620522" },
        { "name": "甘谷县", "code": "620523" }, { "name": "武山县", "code": "620524" },
        { "name": "张家川回族自治县", "code": "620525" }],
        "620600": [{ "name": "凉州区", "code": "620602" }, { "name": "民勤县", "code": "620621" },
        { "name": "古浪县", "code": "620622" }, { "name": "天祝藏族自治县", "code": "620623" }],
        "620700": [{ "name": "甘州区", "code": "620702" }, { "name": "肃南裕固族自治县", "code": "620721" },
        { "name": "民乐县", "code": "620722" }, { "name": "临泽县", "code": "620723" },
        { "name": "高台县", "code": "620724" }, { "name": "山丹县", "code": "620725" }],
        "620800": [{ "name": "崆峒区", "code": "620802" }, { "name": "泾川县", "code": "620821" },
        { "name": "灵台县", "code": "620822" }, { "name": "崇信县", "code": "620823" },
        { "name": "华亭县", "code": "620824" }, { "name": "庄浪县", "code": "620825" },
        { "name": "静宁县", "code": "620826" }],
        "620900": [{ "name": "肃州区", "code": "620902" }, { "name": "金塔县", "code": "620921" },
        { "name": "瓜州县", "code": "620922" }, { "name": "肃北蒙古族自治县", "code": "620923" },
        { "name": "阿克塞哈萨克族自治县", "code": "620924" }, { "name": "玉门市", "code": "620981" },
        { "name": "敦煌市", "code": "620982" }],
        "621000": [{ "name": "西峰区", "code": "621002" }, { "name": "庆城县", "code": "621021" },
        { "name": "环县", "code": "621022" }, { "name": "华池县", "code": "621023" },
        { "name": "合水县", "code": "621024" }, { "name": "正宁县", "code": "621025" },
        { "name": "宁县", "code": "621026" }, { "name": "镇原县", "code": "621027" }],
        "621100": [{ "name": "安定区", "code": "621102" }, { "name": "通渭县", "code": "621121" },
        { "name": "陇西县", "code": "621122" }, { "name": "渭源县", "code": "621123" },
        { "name": "临洮县", "code": "621124" }, { "name": "漳县", "code": "621125" },
        { "name": "岷县", "code": "621126" }],
        "622600": [{ "name": "武都区", "code": "622621" }, { "name": "宕昌县", "code": "622623" },
        { "name": "成县", "code": "622624" }, { "name": "康县", "code": "622625" },
        { "name": "文县", "code": "622626" }, { "name": "西和县", "code": "622627" },
        { "name": "礼县", "code": "622628" }, { "name": "两当县", "code": "622629" },
        { "name": "徽县", "code": "622630" }],
        "622900": [{ "name": "临夏市", "code": "622901" }, { "name": "临夏县", "code": "622921" },
        { "name": "康乐县", "code": "622922" }, { "name": "永靖县", "code": "622923" },
        { "name": "广河县", "code": "622924" }, { "name": "和政县", "code": "622925" },
        { "name": "东乡族自治县", "code": "622926" }, { "name": "积石山保安族东乡族撒", "code": "622927" }]
    },

    locationData: {
        "62": { "extent": [92.3387627443044, 32.5962579001325, 108.711747270075, 42.7945826671283], "level": 8, "centerX": 103.84, "centerY": 36.06 },
        "620600": { "extent": [101.828529204107, 36.7531880277557, 104.19989556221, 39.4607707118052], "level": 12, "centerX": 102.64, "centerY": 37.93 },
        "620100": { "extent": [102.599654371005, 35.5722050334322, 104.574666067269, 36.9985564898601], "level": 12, "centerX": 103.83, "centerY": 36.06 },
        "620700": { "extent": [97.3929708159994, 37.6270014100255, 102.203972176314, 39.8886203244877], "level": 12, "centerX": 100.45, "centerY": 38.93 },
        "620500": { "extent": [104.573843884587, 34.0760431361082, 106.716921515708, 35.176329175138], "level": 12, "centerX": 105.72, "centerY": 34.58 },
        "620800": { "extent": [105.34403502282, 34.8782163429616, 107.86113606521, 35.7514718451996], "level": 12, "centerX": 106.66, "centerY": 35.54 },
        "620300": { "extent": [101.332371086666, 38.0222850593674, 102.727381473444, 38.9951953529806], "level": 12, "centerX": 102.19, "centerY": 38.52 },
        "623000": { "extent": [100.762581159739, 33.1060781841942, 104.759949965743, 35.5894632030388], "level": 12, "centerX": 102.91, "centerY": 34.98 },
        "622600": { "extent": [104.021395991744, 32.5962579001325, 106.580865085988, 34.5343326357138], "level": 12, "centerX": 104.92, "centerY": 33.4 },
        "621100": { "extent": [103.46634503377, 34.1261580522432, 105.647438937015, 36.0452493651321], "level": 12, "centerX": 104.62, "centerY": 35.58 },
        "622900": { "extent": [102.683997387348, 34.9789958084802, 103.857462333692, 36.2217442190917], "level": 12, "centerX": 103.31, "centerY": 35.62 },
        "620900": { "extent": [92.3387627443044, 38.1450851172514, 100.224809315683, 42.7945826671283], "level": 12, "centerX": 98.49, "centerY": 39.73 },
        "620200": { "extent": [97.8480474651722, 39.6533490085612, 98.5196484870047, 39.9990494092607], "level": 12, "centerX": 98.29, "centerY": 39.77 },
        "621000": { "extent": [106.35701379736, 35.2422507371379, 108.711747270075, 37.158300066283], "level": 12, "centerX": 107.63, "centerY": 35.74 },
        "620400": { "extent": [103.545057466833, 35.4124643834032, 105.526219934023, 37.6319410531833], "level": 12, "centerX": 104.14, "centerY": 36.54 },
        "620122": { "extent": [103.549811123, 36.0873707599323, 104.228823409113, 36.8532409444967], "level": 13, "centerX": 103.95, "centerY": 36.33 },
        "621027": { "extent": [106.735323639124, 35.453066809806, 107.601511383024, 36.2762013668543], "level": 13, "centerX": 107.19, "centerY": 35.68 },
        "620104": { "extent": [103.334653373586, 35.968869733843, 103.688732605647, 36.2311756574258], "level": 13, "centerX": 103.63, "centerY": 36.09 },
        "622923": { "extent": [102.880207212108, 35.7611847479466, 103.631802170319, 36.2217442190917], "level": 13, "centerX": 103.31, "centerY": 35.94 },
        "620105": { "extent": [103.571655584945, 36.0777682858367, 103.786123247694, 36.1792675732041], "level": 13, "centerX": 103.72, "centerY": 36.1 },
        "620102": { "extent": [103.776829487468, 35.9618677788974, 103.982921167008, 36.1596650931996], "level": 13, "centerX": 103.82, "centerY": 36.06 },
        "620103": { "extent": [103.614761850682, 35.8409584250709, 103.909999751779, 36.1024753671422], "level": 12, "centerX": 103.78, "centerY": 36.07 },
        "621102": { "extent": [104.211481597162, 35.2988998717303, 105.018897387396, 36.0452493651321], "level": 13, "centerX": 104.61, "centerY": 35.58 },
        "621002": { "extent": [107.465603863944, 35.4263612631809, 107.888407003904, 35.8670316107132], "level": 14, "centerX": 107.6465, "centerY": 35.7307 },
        "621026": { "extent": [107.673578039429, 35.2510170773687, 108.561960209247, 35.866959914063], "level": 13, "centerX": 107.92, "centerY": 35.5 },
        "622927": { "extent": [102.683997387348, 35.5592443892557, 103.104568074584, 35.8622920073516], "level": 13, "centerX": 102.87, "centerY": 35.72 },
        "622921": { "extent": [102.724960109135, 35.3435480907369, 103.295107367281, 35.7984711231166], "level": 13, "centerX": 102.99, "centerY": 35.49 },
        "620826": { "extent": [105.34403502282, 35.02036392935, 106.096180903906, 35.7514718451996], "level": 13, "centerX": 105.73, "centerY": 35.52 },
        "620802": { "extent": [106.42960562006, 35.2715453716308, 107.192568588783, 35.748331727436], "level": 13, "centerX": 106.67, "centerY": 35.54 },
        "622901": { "extent": [103.079885122089, 35.514394338104, 103.280817414529, 35.6546734255952], "level": 13, "centerX": 103.24, "centerY": 35.6 },
        "622924": { "extent": [103.383905705896, 35.2827319673069, 103.857462333692, 35.6356119579385], "level": 13, "centerX": 103.57, "centerY": 35.48 },
        "621025": { "extent": [107.940863267171, 35.2422507371379, 108.633914732786, 35.6043769255507], "level": 13, "centerX": 108.35, "centerY": 35.49 },
        "623027": { "extent": [101.756690319891, 34.5360766099863, 102.975311008636, 35.5894632030388], "level": 13, "centerX": 102.52, "centerY": 35.2 },
        "622925": { "extent": [103.117138567683, 35.24222775946, 103.447691840328, 35.5312757781153], "level": 13, "centerX": 103.35, "centerY": 35.42 },
        "620821": { "extent": [107.10478030482, 35.1748048296943, 107.740849383071, 35.5245623238781], "level": 13, "centerX": 107.36, "centerY": 35.33 },
        "621121": { "extent": [104.793189092307, 34.9222889203264, 105.647438937015, 35.4990501506062], "level": 13, "centerX": 105.24, "centerY": 35.21 },
        "622922": { "extent": [103.421585174725, 34.9789958084802, 103.814201454713, 35.4526607434268], "level": 13, "centerX": 103.71, "centerY": 35.37 },
        "621123": { "extent": [103.735837206764, 34.8869700971806, 104.476108303979, 35.4154686459837], "level": 13, "centerX": 104.21, "centerY": 35.14 },
        "620823": { "extent": [106.815602830557, 35.0252459241671, 107.216312488101, 35.4069808509665], "level": 13, "centerX": 107.03, "centerY": 35.3 },
        "621122": { "extent": [104.313570870357, 34.8406150189217, 104.907332769166, 35.3992653712249], "level": 13, "centerX": 104.63, "centerY": 35 },
        "620824": { "extent": [106.359049714946, 35.0219213347709, 106.87927756417, 35.3940615756034], "level": 13, "centerX": 106.65, "centerY": 35.22 },
        "623001": { "extent": [102.795972054155, 34.5862622910737, 103.401368003617, 35.2887251374436], "level": 13, "centerX": 102.91, "centerY": 35 },
        "620822": { "extent": [107.005166757252, 34.8782163429616, 107.86113606521, 35.2449318877025], "level": 13, "centerX": 107.62, "centerY": 35.07 },
        "620522": { "extent": [105.326233854263, 34.7262585229009, 106.052145946081, 35.176329175138], "level": 13, "centerX": 105.67, "centerY": 34.86 },
        "620525": { "extent": [105.926741684525, 34.7396322256855, 106.575473874353, 35.1728496757236], "level": 13, "centerX": 106.2, "centerY": 34.99 },
        "620521": { "extent": [105.758532155818, 34.53521072475, 106.494851750746, 34.9692648230652], "level": 13, "centerX": 106.13, "centerY": 34.75 },
        "621125": { "extent": [103.961740661028, 34.4286476275301, 104.750779950431, 34.959963148806], "level": 13, "centerX": 104.47, "centerY": 34.85 },
        "620524": { "extent": [104.573843884587, 34.419603979553, 105.142214886397, 34.9544896905746], "level": 13, "centerX": 104.89, "centerY": 34.72 },
        "623026": { "extent": [102.007295746412, 33.9684745132226, 102.970503929143, 34.8269078924948], "level": 13, "centerX": 102.49, "centerY": 34.69 },
        "620503": { "extent": [105.423962026256, 34.1004254839202, 106.716921515708, 34.8081415535497], "level": 13, "centerX": 105.89, "centerY": 34.57 },
        "621126": { "extent": [103.690857061487, 34.1261580522432, 104.990243462292, 34.7500218925412], "level": 13, "centerX": 104.03, "centerY": 34.44 },
        "620502": { "extent": [105.215103023114, 34.0760431361082, 106.014363784569, 34.6809973484822], "level": 13, "centerX": 105.72, "centerY": 34.58 },
        "622628": { "extent": [104.62024523836, 33.5954386699568, 105.560998589285, 34.5343326357138], "level": 13, "centerX": 105.17, "centerY": 34.19 },
        "623025": { "extent": [100.762581159739, 33.1060781841942, 102.48215223988, 34.3849507797145], "level": 13, "centerX": 102.07, "centerY": 34 },
        "622623": { "extent": [104.021395991744, 33.5665336181697, 104.807518510008, 34.3831995452153], "level": 13, "centerX": 104.39, "centerY": 34.05 },
        "623024": { "extent": [102.915631830599, 33.6574065047478, 104.076251464521, 34.3260570974164], "level": 13, "centerX": 103.22, "centerY": 34.06 },
        "622629": { "extent": [106.196167698894, 33.5145077992045, 106.580865085988, 34.2576385372251], "level": 13, "centerX": 106.3, "centerY": 33.91 },
        "622627": { "extent": [105.045526647231, 33.6205873858279, 105.643524815049, 34.2282587468286], "level": 13, "centerX": 105.3, "centerY": 34.01 },
        "622630": { "extent": [105.574787911047, 33.5462125852597, 106.448674313769, 34.1772044330761], "level": 13, "centerX": 106.08, "centerY": 33.77 },
        "622624": { "extent": [105.391144877776, 33.5349479311295, 105.958409181091, 34.04526835695], "level": 13, "centerX": 105.73, "centerY": 33.74 },
        "623023": { "extent": [103.861170044165, 33.2198188289859, 104.759949965743, 34.0170485534757], "level": 13, "centerX": 104.47, "centerY": 33.79 },
        "622621": { "extent": [104.569636563854, 32.7993168985159, 105.640768253634, 33.7084357975628], "level": 13, "centerX": 104.92, "centerY": 33.39 },
        "622625": { "extent": [105.281720741304, 32.8838692635372, 105.97161640408, 33.6511316867364], "level": 13, "centerX": 105.6, "centerY": 33.33 },
        "622626": { "extent": [104.274013513709, 32.5962579001325, 105.455766709002, 33.3430113842783], "level": 13, "centerX": 104.68, "centerY": 32.95 },
        "620922": { "extent": [94.7657769759193, 39.8568181247696, 96.9775927341205, 41.8008587783323], "level": 13, "centerX": 95.78, "centerY": 40.52 },
        "620982": { "extent": [92.7023950453061, 39.6426924517055, 95.5037347443796, 41.5713710410471], "level": 13, "centerX": 94.66, "centerY": 40.14 },
        "620921": { "extent": [98.0264980909367, 39.7956816088735, 100.224809315683, 40.9662569552967], "level": 13, "centerX": 98.9, "centerY": 39.98 },
        "620981": { "extent": [96.484132238327, 39.6262311956307, 98.3316982803765, 40.9186876780843], "level": 13, "centerX": 97.0451, "centerY": 40.2924 },
        "620902": { "extent": [98.3284423218417, 39.1510036221084, 99.3037235790597, 39.9848403181493], "level": 13, "centerX": 98.51, "centerY": 39.74 },
        "620724": { "extent": [98.9583711926032, 39.0717074732904, 100.114283391014, 39.8886203244877], "level": 13, "centerX": 99.82, "centerY": 39.38 },
        "620924": { "extent": [92.3387627443044, 38.1450851172514, 96.6899149153145, 39.86973559969], "level": 13, "centerX": 94.34, "centerY": 39.63 },
        "620723": { "extent": [99.8565438209006, 38.9573748992357, 100.502004136892, 39.7048169879641], "level": 13, "centerX": 100.16, "centerY": 39.15 },
        "620621": { "extent": [101.828529204107, 38.0688898137033, 104.19989556221, 39.4607707118052], "level": 13, "centerX": 103.09, "centerY": 38.62 },
        "620702": { "extent": [100.096947382388, 38.5443544116404, 100.866483092028, 39.4044428681017], "level": 13, "centerX": 100.48, "centerY": 38.93 },
        "620725": { "extent": [100.687525652434, 38.2816449334846, 101.604043146113, 39.0300763016264], "level": 13, "centerX": 101.09, "centerY": 38.78 },
        "620302": { "extent": [101.576942120826, 38.3497058710763, 102.613878126461, 38.9951953529806], "level": 13, "centerX": 102.19, "centerY": 38.52 },
        "620722": { "extent": [100.385171324389, 38.1470094829324, 101.011277031514, 38.8055432234788], "level": 13, "centerX": 100.81, "centerY": 38.43 },
        "620602": { "extent": [102.092384255751, 37.3872407693602, 103.388611662923, 38.2098614052375], "level": 13, "centerX": 102.64, "centerY": 37.93 },
        "620622": { "extent": [102.71775149898, 37.1254271562399, 103.864394185586, 37.9168404183784], "level": 13, "centerX": 102.9, "centerY": 37.47 },
        "620623": { "extent": [102.033316472802, 36.7531880277557, 103.633855699328, 37.8942580204406], "level": 13, "centerX": 103.14, "centerY": 36.97 },
        "620423": { "extent": [103.545057466833, 36.7242379325255, 104.71512949689, 37.6319410531833], "level": 13, "centerX": 104.06, "centerY": 37.18 },
        "620121": { "extent": [102.599654371005, 36.1982914420055, 103.764662726109, 36.9985564898601], "level": 13, "centerX": 103.26, "centerY": 36.74 },
        "620403": { "extent": [104.402381651092, 36.3303292341511, 105.421385566668, 36.9952746857094], "level": 13, "centerX": 104.82, "centerY": 36.73 },
        "621023": { "extent": [107.486781493892, 36.1278866274892, 108.559528777027, 36.855311887078], "level": 13, "centerX": 107.98, "centerY": 36.46 },
        "620402": { "extent": [103.890293057438, 36.2509560377169, 104.413542408347, 36.7856612422168], "level": 13, "centerX": 104.14, "centerY": 36.54 },
        "620111": { "extent": [102.827902119479, 36.1332929711161, 103.370145383672, 36.470322708657], "level": 13, "centerX": 102.86, "centerY": 36.35 },
        "620123": { "extent": [103.823978471027, 35.5722050334322, 104.574666067269, 36.4432515588486], "level": 13, "centerX": 104.11, "centerY": 35.84 },
        "621024": { "extent": [107.843173328954, 35.6333336694688, 108.711747270075, 36.4386442475562], "level": 13, "centerX": 108.01, "centerY": 35.82 },
        "620421": { "extent": [104.259140767007, 36.1679668058985, 105.337562971796, 37.2775065619409], "level": 13, "centerX": 104.68, "centerY": 36.57 },
        "620721": { "extent": [97.3929708159994, 37.6270014100255, 102.203972176314, 39.7792953418667], "level": 13, "centerX": 99.61, "centerY": 38.84 },
        "621022": { "extent": [106.35701379736, 36.0138492271123, 107.743624823953, 37.158300066283], "level": 13, "centerX": 107.3, "centerY": 36.57 },
        "621021": { "extent": [107.277275717233, 35.7095108804562, 108.097558026801, 36.3042895077849], "level": 13, "centerX": 107.88, "centerY": 36.01 },
        "621124": { "extent": [103.46634503377, 35.0613774268593, 104.326418825886, 35.9463366304436], "level": 13, "centerX": 103.86, "centerY": 35.4 },
        "620523": { "extent": [104.975439780824, 34.5198574469051, 105.525169367612, 35.0516258487685], "level": 13, "centerX": 105.33, "centerY": 34.72 },
        "620825": { "extent": [105.76841512126, 35.0514394543854, 106.401734997249, 35.4710500092355], "level": 13, "centerX": 106.03, "centerY": 35.2 },
        "623022": { "extent": [102.767905113842, 34.2110417733655, 104.028044317079, 35.1514711561197], "level": 13, "centerX": 103.5, "centerY": 34.59 },
        "620422": { "extent": [104.497339555104, 35.4124643834032, 105.526219934023, 36.4360296180435], "level": 13, "centerX": 105.05, "centerY": 35.69 },
        "623021": { "extent": [103.177430431336, 34.492544550342, 103.860130534919, 35.0807964631563], "level": 13, "centerX": 103.35, "centerY": 34.69 },
        "620923": { "extent": [94.5504633272327, 38.4251152364185, 98.3300267267085, 42.7945826671283], "level": 13, "centerX": 94.88, "centerY": 39.51 },
        "620321": { "extent": [101.332371086666, 38.0222850593674, 102.727381473444, 38.6276255989014], "level": 13, "centerX": 101.97, "centerY": 38.25 },
        "622926": { "extent": [103.153325634987, 35.4939670610881, 103.74524377165, 35.9273314639431,], "level": 13, "centerX": 103.39, "centerY": 35.66 }
    },

    findLocationData(extent) {
        let findItem = null;
        if (!extent) return findItem;

        let locationDatas = UCDistrictData.locationData;

        let findCode = null;
        let findExtent = null;
        let locationInfo = null;
        let tempExtent = null;
        let intersectStatus = false;
        for (let tempCode in locationDatas) {
            if (tempCode.length < 6) continue;

            locationInfo = locationDatas[tempCode];
            if (!locationInfo) continue;

            tempExtent = locationInfo.extent;

            intersectStatus = GeometryExtentUtility.isIntersect(extent, tempExtent);
            if (intersectStatus) {
                findCode = tempCode;
                findExtent = tempExtent;
                break;
            }
        }

        if (findCode) {
            findItem = {};
            findItem.code = findCode;
            findItem.extent = findExtent;
        }

        return findItem;
    },

    findLocationDatas(mapLevel, extent) {
        let findItems = new Array();
        if (!extent) return findItems;

        let locationDatas = UCDistrictData.locationData;

        let findItem = null;

        let intersectStatus = false;
        for (let tempCode in locationDatas) {
            if (mapLevel > 0 && mapLevel <= 10) {
                if (!(tempCode.length === 2 || (tempCode.length === 6 && tempCode.endsWith("0000")))) {
                    continue;
                }
            }
            else if (mapLevel > 10 && mapLevel < 12) {
                if (!(tempCode.length === 4 || (tempCode.length === 6 && tempCode.endsWith("00")))) {
                    continue;
                }
            }
            else {
                if (tempCode.length != 6 || tempCode.endsWith("00")) {
                    continue;
                }
            }
            let locationInfo = locationDatas[tempCode]
            let tempExtent = locationInfo.extent;

            intersectStatus = GeometryExtentUtility.isIntersect(extent, tempExtent);
            if (intersectStatus) {

                findItem = {};
                findItem.code = tempCode;
                findItem.extent = tempExtent;
                findItems.push(findItem);
            }
        }

        return findItems;
    },



    findXZQData(districtCode) {
        let findItem = null;
        if (!districtCode) return findItem;

        let data = UCDistrictData.xzqData;

        let tempXZQValue = null;
        let tempSubItem = null;
        for (let tempCode in data) {
            tempXZQValue = data[tempCode];
            if (tempXZQValue) {
                for (let tempIndex in tempXZQValue) {
                    tempSubItem = tempXZQValue[tempIndex];
                    if (tempSubItem.code === districtCode) {
                        findItem = tempSubItem;
                        break;
                    }
                }
            }

            if (findItem) {
                break;
            }
        }


        return findItem;
    }




}

export class CityInfo {
    constructor() {

        this.name = null;
        this.code = null;
        this.extent = null;
        this.level = -1;
        this.centerX = -1;
        this.centerY = -1;

    }

    static findCity(mapLevel, extent) {
        let city = null;
        if (!extent) return city;

        let findLocationDatas = UCDistrictData.findLocationDatas(mapLevel, extent);


        let extentX = (extent[0] + extent[2]) / 2.0;
        let extentY = (extent[1] + extent[3]) / 2.0;
        let nearestLocationData = CityInfo._getNearestLocationData(findLocationDatas, extentX, extentY);


        if (nearestLocationData) {
            city = new CityInfo();

            let findXZQData = UCDistrictData.findXZQData(nearestLocationData.code);
            if (findXZQData) {
                city.name = findXZQData.name;
                city.code = findXZQData.code;
                // city.extent = nearestLocationData.extent;
            }
            else {
                city.name = "全省";
                city.code = "62";
            }
        }

        return city;
    }


    static _getNearestLocationData(locationDatas, pointX, pointY) {
        let nearestItem = null;
        if (!locationDatas) return;

        let minDistance = 0;

        let tempLocationData = null;
        // let tempExtentPointX = null;
        // let tempExtentPointY = null;


        let tempLocationDistance = null;
        for (let tempIndex = 0; tempIndex < locationDatas.length; tempIndex++) {
            tempLocationData = locationDatas[tempIndex];
            if (tempLocationData && tempLocationData.extent) {
                // tempExtentPointX = (tempLocationData.extent[0] + tempLocationData.extent[2]) / 2;
                // tempExtentPointY = (tempLocationData.extent[1] + tempLocationData.extent[3]) / 2;
                tempLocationDistance = Math.sqrt(Math.pow(tempLocationData.centerX - pointX, 2) + Math.pow(tempLocationData.centerY - pointY, 2));

                if (tempIndex === 0) {
                    minDistance = tempLocationDistance;
                    nearestItem = tempLocationData;
                }
                else {
                    if (minDistance > tempLocationDistance) {
                        minDistance = tempLocationDistance;
                        nearestItem = tempLocationData;
                    }
                }
            }
        }

        return nearestItem;
    }



}